import type { ReactNode } from 'react'
import { Skeleton } from '@mantine/core'
import { getInitials, type TinyUser } from '@terros/common'
import { AvatarBlurhash } from '../AvatarBlurhash'

type UserAvatarSectionProps = {
  user?: TinyUser | null
  isLoading: boolean
  size?: 'sm' | 'md' | 'lg'
}

export const UserAvatarSection = ({ user, isLoading, size = 'sm' }: UserAvatarSectionProps): ReactNode => {
  const showAvatar = !isLoading && user

  if (showAvatar) {
    return (
      <AvatarBlurhash
        avatarBlurhash={user.avatarBlurhash}
        avatarUrl={user.avatarUrl}
        initials={getInitials(user)}
        size={size}
      />
    )
  }

  return <Skeleton circle h={32} w={32} />
}
